<mat-toolbar class="toolbar">
    <span>{{ sidebarTitle }}</span>
</mat-toolbar>
<div class="content">
    <app-multi-select [label]="submissionTypeLabel" [selectedItemsList]="selectedSubmissionTypeValues"
        [itemsList]="submissionTypeMultiSelectList" (listValuesChange)="onSubmissionTypeValuesChange($event)">
    </app-multi-select>
    <button mat-button color="primary" (click)="manageListItems()" [disabled]="enableManageListItems()">
        <mat-icon>list</mat-icon>
        <span>Manage List Items</span>
    </button>
    <br /><br />
    <button mat-raised-button class="mat-accent" color="primary" (click)="addNewNode()"
        [disabled]="isSaveButtonDisabled()">
        <span>Save</span>
    </button>
    <button mat-button color="primary" (click)="closeForm()">
        <span>Cancel</span>
    </button>

    <span>{{ errorText }}</span>
</div>